export interface AutoconsumptionConfig {
    autoconsumptionRate: number;
    autoproductionRate: number;
    economy: number;
    electricEnergyAutoConsumed: number;
    electricEnergyAutoProduced: number;
    electricEnergySurplus: number;
    investment: number;
    roi: number;
    sellingGain: number;
    totalGain: number;
    totalModuleArea: number;
    totalModuleCount: number;
    totalPowerPeak: number;
    totalProduction: number;
    connectionCost?: number;
}

export interface HousingDefaultConsumption {
    annualConsumption: number;
    subscribedPower: number;
}

export interface MobilityUses {
    electricVehiculeCount: number;
    annualDistance: number;
}

export interface ConnectionCostParameters {
    valorization: string;
    subscribedPower: number;
    elements: any[];
    scaleTypeId?: number;
    territoryIds?: string[];
    year?: number;
    typology?: string;
    uses?: string[];
    electricEnergyConsumed?: number;
    usableFloorArea?: number;
    occupantCount?: number;
    injectedPower?: number;
    moduleArea?: number;
    totalModuleCount?: number;
}

export interface GaugeChartData {
    housingConsumption: number;
    electricEnergyAutoConsumed: number;
    autoproductionRate: number;
}

export interface BarChartData {
    electricEnergySurplus: number;
    electricEnergyAutoConsumed: number;
    totalProduction: number;
}

export interface electricMobilityData {
    distanceRatio: number;
}

export interface ThermalResult {
    annualProduction: number;
    investment: number;
    moduleCount: number;
    peakPower: number;
    personCount: number;
    roi: number;
    help: number;
    netInvestment: number;
    incomeBracketLabel?: string;
    incomeBracket?: 'VERY_LOW' | 'LOW' | 'MEDIUM' | 'HIGH' | 'NO_ANSWER';
    showerCount: number;
    saving: number;
    totalModuleArea: number;
    originalInvestment: number;
    originalRoi: number;
    isOptimal: boolean;
    volumeByYear: number;
    volumeByDay: number;
    equivalentPerson: number;
}

export interface PvTotalityResult {
    annualProduction: number;
    carbonImpacts: number;
    connectionCost?: any;
    investment: number;
    moduleCount: number;
    peakPower: number;
    roi: number;
    totalModuleArea: number;
    sellingGain: number;
    bankLoan?: {
        loan: number | null;
        durationYear: number | null;
        annualInterestRate: number | null;
    };
    originalInvestment: number;
    originalRoi: number;
}

export interface PvSurplusConsumersResults {
    typicalDayConsumption: number[];
    monthlyConsumption: number[];
}

export interface PvSurplusResult {
    annualProduction: number;
    carbonImpacts: number;
    bonus: number;
    connectionCost?: any;
    demandPeakPower: number;
    investment: number;
    moduleCount: number;
    numPanelsBySolarInstallation: number[];
    peakPower: number;
    roi: number;
    saving: number;
    selfConsumptionEnergy: number;
    selfConsumptionRate: number;
    selfProductionRate: number;
    sellingGain: number;
    surplusEnergy: number;
    totalGain: number;
    totalModuleArea: number;
    typicalDayProduction: number[];
    monthlyProduction: number[];
    monthlySelfConsumption: number[];
    monthlyElectricityPurchased: number[];
    monthlyElectricitySold: number[];
    electricMobilityDistanceFromSelfConsumption?: number;
    electricMobilityDistanceRatio?: number;
    electricMobilityAnnualSelfConsumption?: number;
    electricMobilityEconomy?: number;
    optimalElectricMobilityEconomy?: number;
    optimalElectricMobilityAnnualSelfConsumption?: number;
    originalInvestment: number;
    originalRoi: number;
}

export interface PvResults {
    selfConsumption: PvSurplusResult[];
    totality: PvTotalityResult[];
}

export interface Center {
    latitude: number;
    longitude: number;
}
export interface NewRoof {
    center: Center;
    usableRoofArea: number;
    height: number;
    installationType: string;
    orientation: string;
    azimuth: number;
    tilt: number;
    isNew: boolean;
    addressLabel: string;
    parcelLabel: string;
}

export interface HousingConsumptionInputs {
    year: number;
    scaleTypeId: number;
    territoryIds: string;
    usableFloorArea: number;
    occupantCount: number;
    uses: string;
    electricMobility?: string;
}

export interface BankLoanResult {
    investment: number;
    roi: number;
    interest: number;
}

export type WithRoi = {
    roi: number;
};

export type Profile = 'individual' | 'firm' | 'public agency';

export enum ProfileEnum {
    INDIVIDUAL = 'individual',
    FIRM = 'firm',
    PUBLIC_AGENCY = 'public agency',
}

export type Contact = {
    profile: Profile;
    p_peak_min: number | null;
    p_peak_max: number | null;
    template: string;
};

export enum IncomeBracket {
    VERY_LOW = 'Revenus très modestes',
    LOW = 'Revenus modestes',
    MEDIUM = 'Revenus intermédiaires',
    HIGH = 'Revenus supérieurs',
    NO_ANSWER = 'Ne souhaite pas répondre',
}
